import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKoreacard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Korean cards",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M16.778 7.18679L15.6733 8.84567L15.8493 8.96175C15.9467 9.02916 16.0703 9.11154 16.1264 9.14524L16.2275 9.21265L17.3322 7.55376L18.4369 5.89488L18.2609 5.77879C18.1635 5.71139 18.04 5.62901 17.9838 5.5953L17.8827 5.5279L16.778 7.18679Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M29.7984 5.71496L29.5288 5.89471L30.0343 6.65487L30.5399 7.41504L30.641 7.34764C30.6971 7.31393 30.8207 7.23155 30.9181 7.16415L31.0941 7.04806L30.5923 6.29164C30.3114 5.87598 30.083 5.53522 30.0755 5.53522C30.0718 5.53522 29.9482 5.6176 29.7984 5.71496Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M17.6247 7.73718C17.0218 8.6359 16.5312 9.38483 16.5312 9.39606C16.5312 9.42228 17.0592 9.77802 17.0742 9.7593C17.1079 9.7181 19.2649 6.46774 19.2649 6.46025C19.2649 6.44527 18.7518 6.09702 18.7294 6.09702C18.7219 6.09702 18.2238 6.83472 17.6247 7.73718Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_5",
						d: "M28.971 6.26178C28.8437 6.35166 28.7276 6.43404 28.7164 6.44527C28.7014 6.45651 30.7834 9.62823 30.892 9.7593C30.907 9.77802 31.435 9.42228 31.435 9.39606C31.435 9.35862 29.2519 6.09702 29.2294 6.10076C29.2182 6.10076 29.1021 6.17566 28.971 6.26178Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_6",
						d: "M18.4407 8.30634C17.8378 9.21254 17.351 9.96148 17.3585 9.96896C17.366 9.97645 17.4895 10.0588 17.6318 10.1525L17.894 10.3247L18.9912 8.6808C19.594 7.77459 20.0883 7.02566 20.0883 7.01443C20.0883 6.9957 19.6614 6.70362 19.5903 6.67366C19.5566 6.66243 19.1709 7.20915 18.4407 8.30634Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_7",
						d: "M28.1283 6.82727C27.9898 6.92088 27.8774 7.00701 27.8774 7.0145C27.8774 7.02574 28.1021 7.37024 28.3755 7.78216L28.8735 8.52734L29.1356 8.35509C29.2779 8.26147 29.4015 8.17909 29.409 8.1716C29.4277 8.15288 28.4354 6.65876 28.4054 6.65876C28.3942 6.65876 28.2669 6.73365 28.1283 6.82727Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_8",
						d: "M30.9967 7.51257L30.7271 7.69231L31.2326 8.45248L31.7381 9.21265L31.8392 9.14524C31.8954 9.11154 32.019 9.02916 32.1163 8.96175L32.2923 8.84567L31.7905 8.08925C31.5097 7.67359 31.2813 7.33283 31.2738 7.33283C31.27 7.33283 31.1465 7.41521 30.9967 7.51257Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_9",
						d: "M29.3266 8.62463C29.188 8.71825 29.0757 8.80438 29.0757 8.81186C29.0757 8.8231 29.3004 9.16761 29.5737 9.57952L30.0718 10.3247L30.3339 10.1525C30.4762 10.0588 30.5998 9.97645 30.6072 9.96896C30.626 9.95024 29.6336 8.45612 29.6037 8.45612C29.5924 8.45612 29.4651 8.53101 29.3266 8.62463Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_10",
						d: "M17.6167 13.8335C17.4819 13.9271 17.3733 14.0207 17.377 14.0469C17.3808 14.0881 19.4441 17.2149 19.5265 17.3048C19.5564 17.3422 20.0957 16.9977 20.0807 16.9528C20.0545 16.8929 17.8976 13.665 17.8788 13.665C17.8676 13.665 17.7515 13.7399 17.6167 13.8335Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_11",
						d: "M29.5809 14.3953C29.315 14.7997 29.0903 15.1442 29.0828 15.1554C29.0678 15.2004 29.6071 15.5449 29.637 15.5074C29.6857 15.455 30.5769 14.1069 30.5957 14.0582C30.6069 14.032 30.5058 13.9384 30.3523 13.8373C30.2062 13.7399 30.0826 13.6613 30.0789 13.6613C30.0714 13.6613 29.8505 13.9946 29.5809 14.3953Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_12",
						d: "M16.782 14.3953C16.6173 14.5039 16.5311 14.5825 16.5461 14.6162C16.5648 14.6649 17.4486 16.0092 17.501 16.0654C17.5197 16.0879 17.9167 15.852 18.0589 15.7396C18.0739 15.7246 17.0816 14.2268 17.0554 14.223C17.0441 14.223 16.9206 14.3017 16.782 14.3953Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_13",
						d: "M30.3937 14.9757C30.1204 15.3914 29.8994 15.7321 29.9069 15.7396C30.0492 15.852 30.4462 16.0879 30.4649 16.0654C30.5136 16.0092 31.401 14.6649 31.4198 14.6162C31.4385 14.5713 31.079 14.2904 30.9404 14.2417C30.9105 14.2305 30.697 14.5189 30.3937 14.9757Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_14",
						d: "M15.9242 14.9607L15.6733 15.1292L16.7818 16.7881L17.8902 18.4507L18.1635 18.2635L18.4406 18.08L17.3435 16.4323C16.7443 15.5261 16.235 14.7884 16.2126 14.7884C16.1938 14.7884 16.0628 14.867 15.9242 14.9607Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_15",
						d: "M31.2212 15.5334L30.7231 16.2824L31.0002 16.4658L31.2774 16.6531L31.7829 15.8892L32.2922 15.129L32.03 14.9567C31.8877 14.8631 31.7604 14.7845 31.7454 14.7845C31.7267 14.7845 31.4908 15.1215 31.2212 15.5334Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_16",
						d: "M28.3826 16.1926C28.1168 16.597 27.8921 16.9415 27.8846 16.9528C27.8696 16.9977 28.4088 17.3422 28.4388 17.3048C28.4875 17.2524 29.3787 15.9043 29.3974 15.8556C29.4087 15.8294 29.3076 15.7358 29.154 15.6347C29.008 15.5373 28.8844 15.4587 28.8807 15.4587C28.8732 15.4587 28.6522 15.7919 28.3826 16.1926Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_17",
						d: "M17.9803 16.1926C17.8155 16.3012 17.7294 16.3799 17.7443 16.4136C17.7631 16.4623 18.6468 17.8066 18.6992 17.8628C18.718 17.8852 19.1149 17.6493 19.2572 17.537C19.2722 17.522 18.2798 16.0241 18.2536 16.0204C18.2424 16.0204 18.1188 16.099 17.9803 16.1926Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_18",
						d: "M29.1955 16.7731C28.9221 17.1887 28.7012 17.5295 28.7087 17.537C28.851 17.6493 29.2479 17.8852 29.2666 17.8628C29.3153 17.8066 30.2028 16.4623 30.2215 16.4136C30.2402 16.3686 29.8808 16.0878 29.7422 16.0391C29.7122 16.0279 29.4988 16.3162 29.1955 16.7731Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_19",
						d: "M30.0229 17.331L29.5249 18.08L29.802 18.2635L30.0791 18.4507L30.5846 17.6868L31.0939 16.9266L30.8318 16.7544C30.6895 16.6607 30.5622 16.5821 30.5472 16.5821C30.5285 16.5821 30.2926 16.9191 30.0229 17.331Z",
						fill: "white"
					})
				]
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 1",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector 1",
					d: "M24.4741 8.19817C27.9736 8.69261 27.8959 11.9975 27.8959 11.9975C27.8959 11.9975 27.3256 10.6246 25.6406 10.7224C24.7618 10.7734 24.1375 11.1027 23.6965 11.8674C23.4113 12.3619 21.9856 13.4288 20.7414 11.8674C19.7164 10.5813 21.5289 7.78204 24.4741 8.19817Z",
					fill: "#E31124"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector 2",
					d: "M23.6059 15.8173C20.0086 15.3115 20.0885 11.9306 20.0885 11.9306C20.0885 11.9306 20.6748 13.3351 22.4068 13.235C23.3102 13.1828 23.952 12.846 24.4054 12.0637C24.6985 11.5579 26.1641 10.4664 27.4431 12.0637C28.4967 13.3794 26.6336 16.243 23.6059 15.8173Z",
					fill: "#394C9B"
				})]
			})]
		})
	}) })
});
export default SvgKoreacard;
